export default __webpack_public_path__ + "static/dashboard-ru-b10a7515ee2cea7c6671e6134a8498f2.mp4";